import { GROUND } from '../sim/constants';
import type { Target } from '../sim/types';
import { TAU, ell, fillStroke } from './common';

/** Flies and power-ups floating at head height. The bob is cosmetic only. */
export function drawTarget(ctx: CanvasRenderingContext2D, tg: Target, t: number, reduced: boolean): void {
  const bob = reduced ? 0 : Math.sin(t * 3 + tg.id) * 4;
  const x = tg.x;
  const y = GROUND - tg.h + bob;
  const face = tg.vx >= 0 ? 1 : -1;
  ctx.save();
  ctx.translate(x, y);
  switch (tg.kind) {
    case 'fly':
    case 'golden': {
      const golden = tg.kind === 'golden';
      if (golden) {
        const glow = ctx.createRadialGradient(0, 0, 2, 0, 0, 22);
        glow.addColorStop(0, 'rgba(255,220,90,0.8)');
        glow.addColorStop(1, 'rgba(255,220,90,0)');
        ctx.fillStyle = glow;
        ctx.fillRect(-22, -22, 44, 44);
      }
      const flap = reduced ? 0.5 : (Math.sin(t * 55 + tg.id) + 1) / 2;
      ctx.fillStyle = 'rgba(235,245,255,0.75)';
      ell(ctx, -2 * face, -6, 6, 3 + flap * 3, -0.5 * face);
      ctx.fill();
      ell(ctx, 3 * face, -6, 6, 3 + flap * 3, 0.5 * face);
      ctx.fill();
      ell(ctx, 0, 0, 7, 4.5);
      fillStroke(ctx, golden ? '#F2B630' : '#2A2A30', golden ? '#8A5A00' : undefined, 1.5);
      ell(ctx, 6 * face, -1, 3, 3);
      ctx.fillStyle = golden ? '#C9341F' : '#B23A2A';
      ctx.fill();
      break;
    }
    case 'slow': {
      // a blue leaf with a clock
      ctx.rotate(-0.4);
      ctx.beginPath();
      ctx.moveTo(-16, 0);
      ctx.quadraticCurveTo(0, -16, 16, 0);
      ctx.quadraticCurveTo(0, 16, -16, 0);
      fillStroke(ctx, '#7CC6E8', '#2C6C8C', 2);
      ctx.rotate(0.4);
      ell(ctx, 0, 0, 6, 6);
      fillStroke(ctx, '#FFFFFF', '#2C6C8C', 1.5);
      ctx.strokeStyle = '#2C6C8C';
      ctx.beginPath();
      ctx.moveTo(0, 0);
      ctx.lineTo(0, -4);
      ctx.moveTo(0, 0);
      ctx.lineTo(3, 1);
      ctx.stroke();
      break;
    }
    case 'bubble': {
      ell(ctx, 0, 0, 14, 14);
      fillStroke(ctx, 'rgba(190,235,255,0.35)', 'rgba(230,248,255,0.95)', 2);
      ell(ctx, -5, -5, 4, 2.5, -0.6);
      ctx.fillStyle = 'rgba(255,255,255,0.85)';
      ctx.fill();
      break;
    }
    case 'magnet': {
      ctx.lineCap = 'butt';
      ctx.strokeStyle = '#D7263D';
      ctx.lineWidth = 7;
      ctx.beginPath();
      ctx.arc(0, -2, 10, Math.PI, TAU);
      ctx.moveTo(-10, -2);
      ctx.lineTo(-10, 9);
      ctx.moveTo(10, -2);
      ctx.lineTo(10, 9);
      ctx.stroke();
      ctx.strokeStyle = '#E8EEF2';
      ctx.beginPath();
      ctx.moveTo(-10, 6);
      ctx.lineTo(-10, 11);
      ctx.moveTo(10, 6);
      ctx.lineTo(10, 11);
      ctx.stroke();
      break;
    }
  }
  ctx.restore();
}
